import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Chip,
  Grid,
  Radio,
  Typography,
  useTheme,
} from "@mui/material";
import {
  formatCommitType,
  formatLastModifiedDate,
} from "../../store/formatUtil";
import { ExpandMore } from "@mui/icons-material";
import { existsString } from "../../store/validation";

export const HistoryEntryField = ({ value }) => {
  return <Typography variant="body2">{value}</Typography>;
};

const renderAnnotations = (value) => {
  return (
    <Box
      display="flex"
      flex={1}
      flexWrap="wrap"
      gap={1}
      sx={{
        listStyle: "none",
      }}
    >
      {value.map((data) => {
        return (
          <Chip key={data} sx={{ minWidth: 50, maxWidth: 180 }} label={data} />
        );
      })}
    </Box>
  );
};

export const HistoryEntry = ({ commit, onSelected, selectedId }) => {
  const theme = useTheme();
  const formatSeconds = (v) => v + "s";
  const hasComment = existsString(commit.commitComment);

  return (
    <Box
      key={commit.commitId}
      backgroundColor={theme.palette.background.paper}
      border={`1px solid ${theme.palette.divider}`}
      borderRadius={1}
      boxShadow={1}
      mb={1}
      px={1}
      width={1}
    >
      <Grid
        container
        onClick={(e) => {
          e.preventDefault();
          onSelected(commit.commitId);
        }}
        display="flex"
        alignItems="center"
        py={1}
      >
        <Grid display="flex" size={{ xs: 1, lg: 0.5, xl: 0.5 }}>
          <Radio
            checked={commit.commitId === selectedId}
            onChange={(e) => {
              e.preventDefault();
              if (e.target.checked) {
                onSelected(commit.commitId);
              }
            }}
          />
        </Grid>
        <Grid display="flex" size={{ xs: 3.5, lg: 3, xl: 2.5 }}>
          <HistoryEntryField value={formatCommitType(commit.commitType)} />
        </Grid>
        <Grid display="flex" size={{ xs: 3, lg: 3.5, xl: 3 }}>
          <HistoryEntryField
            value={formatLastModifiedDate(commit.createdEpochMs)}
          />
        </Grid>
        <Grid display="flex" size={{ xs: 2, lg: 2, xl: 2.5 }}>
          <HistoryEntryField value={formatSeconds(commit.audioDuration)} />
        </Grid>
        <Grid display="flex" size={{ xs: 2.5, lg: 2, xl: 3.5 }}>
          {renderAnnotations(commit.annotations)}
        </Grid>
      </Grid>
      {hasComment && (
        <Accordion
          sx={{ margin: 0, p: 0, border: "none", boxShadow: "none" }}
          disableGutters={true}
          key={commit.id}
        >
          <AccordionSummary
            sx={{ margin: 0, p: 0 }}
            expandIcon={<ExpandMore />}
          >
            <Typography textTransform="uppercase" variant="caption">
              Comment
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ margin: 0, p: 0 }}>
            <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
              {commit.commitComment}
            </Typography>
          </AccordionDetails>
        </Accordion>
      )}
      <Accordion
        sx={{ margin: 0, p: 0, border: "none", boxShadow: "none" }}
        disableGutters={true}
        key={commit.id}
      >
        <AccordionSummary sx={{ margin: 0, p: 0 }} expandIcon={<ExpandMore />}>
          <Typography textTransform="uppercase" variant="caption">
            Details
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ margin: 0, p: 0, pb: 1 }}>
          <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
            {commit.commitDescription}
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};
